module.exports = __webpack_public_path__ + "images/emoji/meat_on_bone.6010d134371be52438ef.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/meat_on_bone.png
// module id = LdFI
// module chunks = 13